































import Vue from 'vue';
import { MASS } from '@/mass/models/Mass';
import massClient from '../../apis';

const rightsText: string | null = null;
let rightsType: number | undefined;

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rights: {
      type: String,
      default: 'broadcast',
    },
    superAdmin: {
      type: Object,
      default: null,
    },
    admin: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      MASS,
      rightsText,
      rightsType,
      showAddRightsBox: false,
      defaultNickname: '未知用户',
      sended: false,
      isSending: false,
      defaultAvatar: '',
    };
  },
  methods: {
    getImgUrl(customer: any) {
      if (customer) {
        return customer.wxProps.headimgurl.replace('http://', 'https://');
      } else {
        return this.defaultAvatar;
      }
    },
    getNickname(customer: any) {
      if (customer) {
        return customer.wxProps.nickname;
      } else {
        return this.defaultNickname;
      }
    },
    sendHelperRightApplyTpl() {
      this.isSending = true;
      massClient.sendHelperRightApplyTpl({
        openid: this.admin.openid,
        rightsType: this.rightsType,
      }).success((r) => {
        this.isSending = false;
        this.sended = true;
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    initRightsInfo() {
      switch (this.rights) {
        case MASS.RIGHTS.MASS:
          this.rightsText = '公众号群发';
          this.rightsType = 1;
          break;
        case MASS.RIGHTS.BROADCAST:
          this.rightsText = '广播';
          this.rightsType = 3;
          break;
        case MASS.RIGHTS.SMS:
          this.rightsText = '短信';
          this.rightsType = 5;
          break;
        case MASS.RIGHTS.TEMPLATE_SEND:
          this.rightsText = '模板群发';
          this.rightsType = 6;
          break;
        default:
          break;
      }
    },
    confirmAdd() {
      this.init();
      this.$emit('confirm');
    },
    init() {
      this.sended = false;
      this.isSending = false;
    },
    close() {
      this.init();
      this.$emit('close');
    },
  },
  mounted() {
    this.showAddRightsBox = this.show;
  },
  watch: {
    show() {
      this.showAddRightsBox = this.show;
      if (this.showAddRightsBox) {
        this.initRightsInfo();
      }
    },
  },
});
